import hproLog from './log';

var context = self || window;
var contextType = 'window';
try {
    if (ServiceWorkerGlobalScope) {
        contextType = 'worker';
    }
}
catch (e) {

}

var utils = {
    getContext: function () {
        return context;
    },
    getContextType: function () {
        return contextType;
    },
    isFunction: function (value) {
        return typeof value === 'function';
    },
    isObject: function (value) {
        return value !== null && typeof value === 'object';
    },
    isString: function (value) {
        return value !== null && typeof value == 'string';
    },
    merge: function (dst, src) {
        for (var i in src) {
            if (utils.isObject(src[i])) {
                dst[i] = utils.merge({}, src[i]);
            }
            else {
                dst[i] = src[i];
            }
        }

        return dst;
    },
    urlBase64ToUint8Array: function (base64String) {
        var padding = '='.repeat((4 - base64String.length % 4) % 4);
        var base64 = (base64String + padding)
            .replace(/\-/g, '+')
            .replace(/_/g, '/');

        var rawData = context.atob(base64);
        var outputArray = new Uint8Array(rawData.length);
        
        for (var i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    },
    applyPromiseCallbacks: function (p, s, e) {
        if (p) {
            if (s) {
                p.then(s);
            }
            if (e) {
                p.catch(e);
            }
        }

        return p;
    },
    rejectWithReason: function (reject, reason, description) {
        return function (data) {
            var rejectionReason = {
                reason: reason,
                description: description,
                data: data,
                prev: data && data['reason'] ? data : null
            };
            hproLog('reject with reason', rejectionReason);
            reject(rejectionReason);
        }
    }
};

export default utils;


//////////////////
// WEBPACK FOOTER
// ./src/services/utils.js
// module id = 1
// module chunks = 0